import { FC } from "react";

interface Props {
  model: any;
  onChange: (model: string) => void;
}

export const ModelSelect: FC<Props> = ({ model, onChange }) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value as string);
  };

  return (
    <select
      className="select select-bordered h-[48px] w-[160px] dark:bg-neutral px-6 py-2 dark:text-neutral-200 focus:outline-none"
      value={model}
      onChange={handleChange}
    >
      <option value="gpt-3.5-turbo">GPT-3.5</option>
      <option value="gpt-4">GPT-4o</option>
    </select>
  );
};
